'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var every = require('../iterable/every');
var getKeys = require('../utils/getKeys');
var hasKey = require('../iterable/hasKey');

var deepCompare = function deepCompare(object1, object2) {
  var _map = [object1, object2].map(getKeys),
      _map2 = _slicedToArray(_map, 2),
      keys1 = _map2[0],
      keys2 = _map2[1];

  return keys1.length === keys2.length && object1.toString() === object2.toString() && every(keys1, function (key) {
    return hasKey(object2, key);
  }) && every(keys2, function (key) {
    return hasKey(object1, key);
  }) && every(keys1, function (key) {
    return compare(object1[key], object2[key]);
  });
};

var compare = function compare(item1, item2) {
  if (item1 instanceof Object && item2 instanceof Object) {
    return item1 === item2 || deepCompare(item1, item2);
  }
  return item1 === item2;
};

module.exports = compare;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/misc/deepEqual.js
// module id = 2189
// module chunks = 37